<template>
    <b-tabs id="tbasRsaRefertiList" ref="tbasRsaRefertiList" v-model="activeTabIndex" nav-wrapper-class="sa-tab-items" content-class="mt-3" class="sa-tab" style="height: 100%; padding-bottom: 25px" fill @input="onInputTabs">
        <b-tab title="Referti" id="tbReferti" v-if="isTabReferti">
            <div class="sa-flexbox" style="padding-bottom: 20px">
                <div style="margin-left: 0.5rem; margin-right: 1.5rem">
                    <span class="sa-flexbox-body-title">Referti</span>
                    <b-button size="sm" variant="outline-success outline-primary-noborder float-sm-right" :hidden="false" @click="onClickNuovoAllegato" class="mb-2">
                        <font-awesome-icon icon="plus"> </font-awesome-icon>
                        Aggiungi
                    </b-button>
                </div>
                <allegato-model-component ref="cmpAllegatoModel" :disableRefresh="true" :idRisorsa="idAccettazione" @updateFiles="onUpdateFile()" :jsonData="jsonDataAccettazione"> </allegato-model-component>
                <b-modal ref="mdlAllegati" id="mdlAllegati" size="xl" style="height: 100%" @show="onShowModalAllegati" @hidden="onHideModalAllegati">
                    <paziente-allegati-edit-component :jsonData="jsonDataAllegato" tipoRisorsa="EVENTO"></paziente-allegati-edit-component>
                    <template #modal-footer="{ btnSalva }">
                        <b-button :id="btnSalva" size="sm" variant="success" @click="onSalvaAllegato">Salva</b-button>
                    </template>
                </b-modal>
            </div>
            <!--   </div> -->
        </b-tab>
        <b-tab title="Richieste" id="tbRichiesteLaboratorio">
            <div class="sa-flexbox" style="padding-bottom: 20px">
                <div class="sa-page-search-component">
                    <b-form style="width: 100%" @submit.prevent="onSubmit">
                        <b-row class="sa-form-btn-filter">
                            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                <label class="sa-label-data">Struttura Erogatrice</label>
                                <input class="sa-page-search-component-input" v-model="filtroGestioneReferti.descrizioneLaboratorio" placeholder="Inserisci struttura..." />
                                <button class="sa-page-search-component-btn-search" title="Struttura Erogatrice">
                                    <i class="fas fa-search"></i>
                                </button>
                            </b-col>

                            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                <div class="sa-page-search-component-input-group" style="flex: 1; min-width: 70px">
                                    <label class="sa-label-data">Tipo</label>
                                    <select class="sa-prescrizione-input sa-select-flex" v-model="filtroGestioneReferti.tipo">
                                        <option v-for="item in richiestaLaboratorioTipiList" :key="item.codice" :value="item.codice">
                                            {{ item.descrizione }}
                                        </option>
                                    </select>
                                </div>
                            </b-col>

                            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                <label class="sa-label-data">Esame</label>
                                <input class="sa-page-search-component-input" v-model="filtroGestioneReferti.descrizioneEsame" placeholder="Inserisci esame..." />
                                <button class="sa-page-search-component-btn-search" title="Esame">
                                    <i class="fas fa-search"></i>
                                </button>
                            </b-col>

                            <b-col cols="12" sm="12" md="6" lg="6" xl="6">
                                <label class="sa-label-data">Data richiesta dal</label>
                                <div class="sa-page-search-component-wrapper" style="flex: 1; min-width: 70px">
                                    <date-picker class="sa-date-like-input" input-class="sa-page-search-component-input" format="DD-MM-YYYY" value-type="timestamp" v-model="filtroGestioneReferti.dataRichiestaDal" type="date" placeholder="Inserisci data..." />
                                </div>
                            </b-col>

                            <b-col cols="12" sm="12" md="6" lg="6" xl="6">
                                <label class="sa-label-data">Data richiesta al</label>
                                <div class="sa-page-search-component-wrapper" style="flex: 1; min-width: 70px">
                                    <date-picker class="sa-date-like-input" input-class="sa-page-search-component-input" format="DD-MM-YYYY" value-type="timestamp" v-model="filtroGestioneReferti.dataRichiestaAl" type="date" placeholder="Inserisci data..." />
                                </div>
                                <button class="sa-page-search-component-btn-reset" type="button" @click="onReset">
                                    <i class="fas fa-trash"></i>
                                </button>
                            </b-col>
                        </b-row>
                    </b-form>
                </div>
                <div class="sa-flexbox-body">
                    <div class="b-table-sticky-header">
                        <span v-if="isGestioneOspiti" class="sa-flexbox-body-title">Richieste</span>
                        <b-button v-if="isGestioneOspiti" size="sm" variant="outline-success outline-primary-noborder sa-margin-right float-sm-right" :hidden="false" @click="onNuovaRichiesta" class="mb-2">
                            <font-awesome-icon icon="plus"> </font-awesome-icon>
                            Aggiungi
                        </b-button>
                        <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="visibleFields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                            <template v-slot:cell(nominativo)="{ item }">
                                <span>
                                    <b>{{ item.cognome }} {{ item.nome }}</b></span
                                >
                                <br />
                                <span>{{ item.identificativo }} </span>
                            </template>
                            <template v-slot:cell(strutturaErogatrice)="{ item }">
                                <span>{{ item.descrizioneLaboratorio }} ({{ item.codiceLaboratorio }})</span>
                            </template>
                            <template v-slot:cell(tipo)="{ item }">
                                <span>{{ item.tipo }}</span>
                            </template>
                            <template v-slot:cell(esame)="{ item }">
                                <span>{{ item.esame }}</span>
                            </template>
                            <template v-slot:cell(dataRichiesta)="{ item }">
                                <span>{{ formatDate(item.dataRichiesta) }}</span>
                            </template>
                            <template v-slot:cell(dataOraPrelievo)="{ item }">
                                <span>{{ formatDateTime(item.dataOraPrelievo) }}</span>
                            </template>
                            <template v-slot:cell(statoAttuale)="{ item }">
                                <span :class="getClassStato(item.statoAttuale)">{{ item.statoAttuale }}</span>
                            </template>
                            <template #row-details>
                                <div class="sa-table-row-details">
                                    <b-table sticky-header ref="tblReferti" stacked="lg" striped hover :items="itemsReferti" :fields="fieldsReferti" sort-icon-left head-variant="light" class="sa-b-table">
                                        <template v-slot:cell(createDate)="{ item }">
                                            <span>{{ formatDateTime(item.createDate) }}</span>
                                        </template>
                                        <template v-slot:cell(actions)="row">
                                            <b-container class="bv-example-row">
                                                <b-button size="sm" v-b-tooltip.hover title="Visualizza PDF" variant="outline-secondary no-text" @click="onClickVisualizzaPdf(row)">
                                                    <i class="bi bi-filetype-pdf"></i>
                                                </b-button>
                                            </b-container>
                                        </template>
                                    </b-table>
                                </div>
                            </template>
                            <template v-slot:cell(actions)="row">
                                <b-container class="bv-example-row">
                                    <b-button size="sm" v-b-tooltip.hover title="Nuova Richiesta" variant="outline-info" @click="onClickNuovaRichiesta(row)">
                                        <font-awesome-icon icon="plus"></font-awesome-icon>
                                    </b-button>
                                    <b-button v-if="row.item.tipo === 'CONSULENZA' && row.item.statoAttuale !== 'REFERTATO'" size="sm" v-b-tooltip.hover title="Referta" variant="outline-success" @click="onReferta(row)">
                                        <i class="bi bi-pencil"></i>
                                    </b-button>
                                    <b-button v-if="(row.item.statoAttuale === 'NON INVIATO' || row.item.statoAttuale === 'ERROR') && row.item.tipo !== 'CONSULENZA'" size="sm" v-b-tooltip.hover title="Invia a Laboratorio" variant="outline-success" @click="onClickSend(row.item, 'INVIO IN CORSO')">
                                        <font-awesome-icon icon="paper-plane"></font-awesome-icon>
                                    </b-button>

                                    <b-button v-if="row.item.statoAttuale === 'NON INVIATO' || row.item.statoAttuale === 'ERROR'" size="sm" v-b-tooltip.hover title="Modifica Richiesta" variant="outline-success" @click="onEditRichiestaEsame(row.item)">
                                        <font-awesome-icon icon="edit"></font-awesome-icon>
                                    </b-button>
                                    <b-button v-if="row.item.statoAttuale === 'ATTESA REFERTO' && row.item.tipo === 'LABORATORY'" size="sm" v-b-tooltip.hover title="Stampa etichetta" variant="outline-success no-text" @click="onClickStampaEtichetta(row.item)">
                                        <b-icon icon="printer"></b-icon>
                                    </b-button>
                                    <!-- v-if="item.statoAttuale === 'ERROR'" bi bi-info-square-->
                                    <b-button v-if="row.item.tipo !== 'CONSULENZA'" size="sm" v-b-tooltip.hover title="Info" variant="outline-primary" @click="onClickInfo(row)">
                                        <font-awesome-icon icon="info-circle" />
                                    </b-button>
                                    <b-button size="sm" v-b-tooltip.hover title="Visualizza Referti" variant="outline-secondary" @click="onClickVisualizzaDettagli(row)">
                                        <font-awesome-icon icon="file-medical"></font-awesome-icon>
                                    </b-button>
                                    <b-button v-if="row.item.statoAttuale === 'NON INVIATO'" size="sm" v-b-tooltip.hover title="Cancella Richiesta" variant="outline-danger" @click="onDeleteRichiestaEsame(row.item)">
                                        <font-awesome-icon icon="trash"></font-awesome-icon>
                                    </b-button>
                                </b-container>
                            </template>
                        </b-table>
                    </div>
                </div>
                <div class="sa-flexbox-footer" style="background-color: ciano">
                    <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                        <b-col lg="3">
                            <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                        </b-col>
                        <b-col lg="9">
                            <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                        </b-col>
                    </b-row>
                </div>
                <rsa-gestione-ospiti-edit-richiesta-esame-component ref="cmpRsaGestioneOspitiEditRichiestaEsameComponent" @beforeLoadData="onBeforeLoadDataRsaGestioneOspitiEditRichiestaEsameComponent" @afterLoadData="onAfterLoadDataRsaGestioneOspitiEditRichiestaEsameComponent" @beforeSaveRequest="onBeforeSaveRequestRsaGestioneOspitiEditRichiestaEsameComponent" @afterSaveRequest="onAfterSaveRequestRsaGestioneOspitiEditRichiestaEsameComponent"></rsa-gestione-ospiti-edit-richiesta-esame-component>
                <rsa-gestione-ospiti-richiesta-esame-info-list-component ref="cmpRsaGestioneOspitiRichiestaEsameInfoListComponent" @beforeLoadData="onBeforeLoadDataRsaGestioneOspitiEditRichiestaEsameComponent" @afterLoadData="onAfterLoadDataRsaGestioneOspitiEditRichiestaEsameComponent"></rsa-gestione-ospiti-richiesta-esame-info-list-component>
                <hl7-integrator-log-view-modal-component ref="cmpHl7IntegratorLogViewModalComponent"></hl7-integrator-log-view-modal-component>
                <sa-modal-loading ref="cmpSaModalLoading" />
                <pdf-print-view-embedded ref="pdfPrintViewEmbedded" :pdf="signedPdfViewer"></pdf-print-view-embedded>
                <rsa-paziente-referto-modal-edit-component ref="cmpRsaPazienteRefertoModalEdit" @saveSuccess="onSaveSuccess"></rsa-paziente-referto-modal-edit-component>
            </div>
        </b-tab>
    </b-tabs>
</template>

<script>
import axios from "axios";
import DatePicker from "vue2-datepicker";
import UtilityMixin from "../../../utility/UtilityMixin";
import RsaGestioneOspitiEditRichiestaEsameComponent from "./RsaGestioneOspitiEditRichiestaEsameComponent.vue";
import { SaModalLoading } from "../../../../template/components/modal";
import RsaGestioneOspitiRichiestaEsameInfoListComponent from "./RsaGestioneOspitiRichiestaEsameInfoListComponent.vue";
import Hl7IntegratorLogViewModalComponent from "../../../utility/hl7integrator/components/Hl7IntegratorLogViewModalComponent.vue";
import PdfPrintViewEmbedded from "../../../utility/components/PdfPrintViewEmbedded.vue";
import AllegatoModelComponent from "../../../utility/components/AllegatoModelComponent.vue";
import PazienteAllegatiEditComponent from "../../../paziente/allegati/components/PazienteAllegatiEditComponent.vue";
import RsaPazienteRefertoModalEditComponent from "../../rsapaziente/components/RsaPazienteRefertoModalEditComponent.vue";
// import CodiciIcdIxListComponent from "../../../configurazione/components/CodiciIcdIxListComponent.vue";
export default {
    props: {
        //   jsonDataAccettazione: {
        //         type: Object,
        //         default: function () {
        //             return { id: null };
        //         },
        //     },
        isTabReferti: {
            type: Boolean,
            default: function () {
                return false;
            },
        },
        isGestioneOspiti: {
            type: Boolean,
            default: function () {
                return false;
            },
        },
        idAccettazione: { type: String, default: null },

        visualizzaDatiPaziente: {
            type: Boolean,
            default: function () {
                return true;
            },
        },
    },
    mixins: [UtilityMixin],
    components: {
        DatePicker,
        SaModalLoading,
        RsaGestioneOspitiEditRichiestaEsameComponent,
        RsaGestioneOspitiRichiestaEsameInfoListComponent,
        Hl7IntegratorLogViewModalComponent,
        PdfPrintViewEmbedded,
        AllegatoModelComponent,
        PazienteAllegatiEditComponent,
        RsaPazienteRefertoModalEditComponent,
    },
    computed: {
        /*
        jsonDataAccettazione() {
            let me = this;
            return me.jsonDataAccettazione;
        }, */

        visibleFields() {
            return this.fields.filter((field) => field.visible);
        },
    },
    data() {
        return {
            rows: 0,
            perPage: 50,
            currentPage: 1,
            filtroGestioneReferti: { descrizioneLaboratorio: null, tipo: "", descrizioneEsame: null, dataRichiestaDal: null, dataRichiestaAl: null, idAccettazione: null },
            items: [],
            richiestaLaboratorioTipiList: [{ codice: "", descrizione: "-Seleziona Valore-" }],
            listKey: 0,
            pathResource: "/rsarichiestelaboratorio",
            pathResourceSend: "/rsarichiestelaboratorio/invia",
            pathResourceStampaEtichetta: "/rsarichiestelaboratorio/downloadetichetta",
            pathResourceRepository: "/documentrepository",
            pathResourceRichiestaLaboratorioTipo: "/rsarichiestelaboratoritipo",
            pathResourceAllegati: "/allegati",
            signedPdfViewer: null,
            idAccettazioneInterno: null,
            jsonDataAccettazione: {},
            jsonDataAllegato: {},
            rigaSelezionata: {},
            tipoFileEtichetta: ".eti",
            activeTabIndex: 0,
            fields: [
                {
                    label: "Cognome/Nome",
                    key: "nominativo",
                    sortable: false,
                    visible: this.visualizzaDatiPaziente,
                },
                {
                    label: "Cod. Richiesta",
                    key: "codiceRichiesta",
                    sortable: false,
                    visible: true,
                },
                {
                    label: "Struttura Erogatrice",
                    key: "strutturaErogatrice",
                    sortable: true,
                    visible: true,
                },
                {
                    label: "Tipo",
                    key: "tipo",
                    sortable: true,
                    visible: true,
                },
                {
                    label: "Reparto",
                    key: "descrizioneReparto",
                    sortable: true,
                    visible: true,
                },
                {
                    label: "Esame",
                    key: "descrizioneEsame",
                    visible: true,
                },
                { label: "Data Richiesta", key: "dataRichiesta" },
                {
                    label: "Data e Ora Prelievo",
                    key: "dataOraPrelievo",
                    visible: true,
                },
                {
                    label: "Stato",
                    key: "statoAttuale",
                    visible: true,
                },
                { class: "sa-table-column-action-double", key: "actions", label: "", visible: true }, ///, thStyle: "width: 15rem"
            ],
            itemsReferti: [],
            fieldsReferti: [
                {
                    label: "Rata/Ora Ricezione",
                    key: "createDate",
                    visible: true,
                },
                {
                    label: "Tipo",
                    key: "tipoDocumento",
                    sortable: false,
                },
                { class: "sa-table-column-action-double", key: "actions", label: "", visible: true }, ///, thStyle: "width: 15rem"
            ],
            columnsProperty: [
                { key: "cognome", type: "string", label: "Cognome", visible: true },
                { key: "nome", type: "string", label: "Nome", visible: true },
                { key: "identificativo", type: "string", label: "Identificativo", visible: true },
                { key: "codiceRichiesta", type: "string", label: "Codice richiesta", visible: true },
                { key: "descrizioneLaboratorio", type: "string", label: "Descrizione laboratorio", visible: true },
                { key: "codiceLaboratorio", type: "string", label: "Codice laboratorio", visible: true },
                { key: "tipo", type: "string", label: "Tipo", visible: true },
                { key: "descrizioneReparto", type: "string", label: "Reparto", visible: true },
                { key: "descrizioneEsame", type: "string", label: "Esame", visible: true },
                { key: "dataRichiesta", type: "date", label: "Data richiesta", visible: true },
                { key: "dataOraPrelievo", type: "date", label: "Data prelievo", visible: true },
                { key: "statoAttuale", type: "string", label: "Stato", visible: true },
                { key: "descrizioneQuesitoDiagnostico", type: "string", label: "Quesito diangostico", visible: true },
            ],
        };
    },
    mounted() {
        let me = this;
        me.loadTipiRichiesta();
    },
    watch: {
        currentPage() {
            let me = this;
            me.loadData();
        },
        "filtroGestioneReferti.dataRichiestaDal"(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.filtroGestioneReferti.dataRichiestaAl = newValue;
            }
        },

        "filtroGestioneReferti.dataRichiestaAl"(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.onSubmit();
            }
        },

        "filtroGestioneReferti.tipo"(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.onSubmit();
            }
        },
    },
    methods: {
        init(data) {
            let me = this;
            me.jsonDataAccettazione = data;
            this.tipoFileEtichetta = this.appConfig.tipoFileEtichetta;
            me.loadTipiRichiesta();
            me.loadData();
        },
        onInputTabs(value) {
            let me = this;
            let activeTab = this.$refs.tbasRsaRefertiList.getTabs()[value];

            me.activeTab(activeTab.id);
        },
        activeTab(idActiveTab) {
            let me = this;
            switch (idActiveTab) {
                case "tbReferti":
                    me.$refs.cmpAllegatoModel.loadData();
                    break;
                case "tbRichiesteLaboratorio":
                    me.loadData();

                    break;
            }
        },
        getClassStato(value) {
            let returnValue = "";
            switch (value) {
                case "ERROR":
                    returnValue = "text-danger";
                    break;
            }
            return returnValue;
        },
        loadData() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            if (sessionStorage["filtroGestioneReferti"]) {
                me.filtroGestioneReferti = JSON.parse(sessionStorage["filtroGestioneReferti"]);
            }

            let link = process.env.VUE_APP_PATH_API + me.pathResource;
            me.filtroGestioneReferti.page = me.currentPage;
            me.filtroGestioneReferti.forPage = me.perPage;
            me.filtroGestioneReferti.idAccettazione = me.jsonDataAccettazione.id;
            me.$emit("beforeLoadData");
            axios
                .get(link, { params: me.filtroGestioneReferti })
                .then((response) => {
                    me.items = [];
                    me.rows = response.data.data.recordsNumber;
                    response.data.data.list.forEach((element) => {
                        element.listaReferti = [];
                        me.items.push(element);
                    });
                    me.listKey++;
                    this.$emit("afterLoadData");
                })
                .catch(() => {
                    this.$emit("afterLoadData");
                });
        },
        onReset() {
            let me = this;
            me.filtroGestioneReferti = { tipo: "" };
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroGestioneReferti"] = JSON.stringify(me.filtroGestioneReferti);
            me.loadData();
        },
        onClickNuovaRichiesta(row) {
            let me = this;
            me.idAccettazioneInterno = row.item.idAccettazione;
            me.nuovaRichiesta();
        },

        onNuovaRichiesta() {
            console.log("ECCOMI");
            this.nuovaRichiesta();
        },
        nuovaRichiesta() {
            console.log("ECCOMI");

            let me = this;
            let idAccettazione = me.idAccettazioneInterno === null ? me.idAccettazione : me.idAccettazioneInterno;
            let url = process.env.VUE_APP_PATH_API + "/rsaaccettazioni/" + idAccettazione;
            axios
                .get(url)
                .then((response) => {
                    let accettazione = response.data.data;

                    if (accettazione.statoAttuale === "DIMISSIONE" || accettazione.statoAttuale === "TRASFERITO" || accettazione.statoAttuale === "ASSENTE") {
                        let messaggio = accettazione.statoAttuale === "ASSENTE" ? "Non è possibile questa operazione su un paziente assente" : "Non è possibile questa oeprazione su un paziente dimesso";
                        me.$bvModal.msgBoxOk(messaggio, {
                            title: "ATTENZIONE",
                            size: "sm",
                            okVariant: "outline-danger",
                            headerClass: "sa-msg-header-danger",
                            footerClass: "p-2 border-top-0",
                            centered: true,
                        });
                    } else {
                        if (me.idAccettazioneInterno === null) {
                            me.openEditModal("-1");
                        } else {
                            me.openEditModal("-1", accettazione);
                        }
                    }
                })
                .catch((error) => {
                    console.error("Errore nel recupero dei dati accettazione:", error);
                    me.$bvToast.toast("Errore nel recupero dei dati del paziente.", {
                        title: "Errore",
                        variant: "danger",
                        solid: true,
                    });
                });
        },

        onEditRichiestaEsame(item) {
            let me = this;
            me.openEditModal(item.id);
        },
        openEditModal(id, accettazione = null) {
            let me = this;
            if (accettazione === null) {
                me.$refs.cmpRsaGestioneOspitiEditRichiestaEsameComponent.setJsonDataAccettazione(me.jsonDataAccettazione);
            } else {
                me.$refs.cmpRsaGestioneOspitiEditRichiestaEsameComponent.setJsonDataAccettazione(accettazione);
            }
            me.$refs.cmpRsaGestioneOspitiEditRichiestaEsameComponent.setIdRichiestaEsami(id);
            me.$refs.cmpRsaGestioneOspitiEditRichiestaEsameComponent.loadLaboratori();
            me.$refs.cmpRsaGestioneOspitiEditRichiestaEsameComponent.show();
        },
        onSubmit() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroGestioneReferti"] = JSON.stringify(me.filtroGestioneReferti);
            me.loadData();
        },
        onBeforeLoadDataRsaGestioneOspitiEditRichiestaEsameComponent() {
            let me = this;
            me.$emit("beforeLoadData");
        },
        onAfterLoadDataRsaGestioneOspitiEditRichiestaEsameComponent() {
            let me = this;
            me.$emit("afterLoadData");
        },
        onBeforeSaveRequestRsaGestioneOspitiEditRichiestaEsameComponent() {
            let me = this;
            me.$emit("beforeLoadData");
        },
        onAfterSaveRequestRsaGestioneOspitiEditRichiestaEsameComponent() {
            let me = this;
            me.$refs.cmpRsaGestioneOspitiEditRichiestaEsameComponent.close();
            this.$bvToast.toast(`Richiesta salvata correttamente`, {
                title: "Richiesta Esami",
                solid: true,
                variant: "success",
                autoHideDelay: 5000,
                appendToast: true,
            });
            me.loadData();
        },
        onClickSend(item) {
            // console.log(item);
            let me = this;
            me.$refs.cmpSaModalLoading.show();
            let link = process.env.VUE_APP_PATH_API + me.pathResourceSend + "/" + item.id;
            axios
                .put(link)
                .then(() => {
                    me.$refs.cmpSaModalLoading.close();
                    me.$refs.cmpRsaGestioneOspitiEditRichiestaEsameComponent.close();
                    me.loadData();
                    this.$bvToast.toast(`Richiesta inoltrata`, {
                        title: "Richiesta Esami",
                        solid: true,
                        variant: "success",
                        autoHideDelay: 5000,
                        appendToast: true,
                    });
                })
                .catch(() => {
                    me.$refs.cmpSaModalLoading.close();
                    this.$emit("afterLoadData");
                });
        },
        onClickInfo(value) {
            let me = this;
            me.$refs.cmpHl7IntegratorLogViewModalComponent.show(value.item.id);
        },
        onReferta(value) {
            let me = this;
            me.$refs.cmpRsaPazienteRefertoModalEdit.openModal(value.item);
            // me.$refs.cmpHl7IntegratorLogViewModalComponent.show(value.item.id);
            // console.log(value.item.id);
        },
        onClickStampaEtichetta(item) {
            let me = this;
            me.$refs.cmpSaModalLoading.show();
            let link = process.env.VUE_APP_PATH_API + me.pathResourceStampaEtichetta + "/" + item.id;

            axios
                .get(link)
                .then((response) => {
                    me.$refs.cmpSaModalLoading.close();

                    let base64Data = response.data.data.etichettaBase64;
                    let base64Decoded = atob(base64Data);
                    let blob;
                    if (me.tipoFileEtichetta === ".pdf") {
                        let byteNumbers = new Array(base64Decoded.length);
                        for (let i = 0; i < base64Decoded.length; i++) {
                            byteNumbers[i] = base64Decoded.charCodeAt(i);
                        }
                        let byteArray = new Uint8Array(byteNumbers);
                        blob = new Blob([byteArray], { type: "application/pdf" });
                    } else {
                        blob = new Blob([base64Decoded]);
                    }

                    // --- PROCEDURA DI DOWNLOAD ---
                    var downloadElement = document.createElement("a");
                    var href = window.URL.createObjectURL(blob);
                    downloadElement.href = href;
                    downloadElement.download = "etichetta" + me.tipoFileEtichetta;

                    document.body.appendChild(downloadElement);
                    downloadElement.click();

                    document.body.removeChild(downloadElement);
                    window.URL.revokeObjectURL(href);
                })
                .catch((error) => {
                    console.error("Errore stampa:", error);
                    me.$refs.cmpSaModalLoading.close();
                });
        },
        onClickVisualizzaDettagli(row) {
            let me = this;
            console.log(row);

            if (!row.detailsShowing) {
                me.loadReferti(row);
            }
            row.toggleDetails();
        },
        loadReferti(row) {
            let me = this;
            // console.log(row);
            me.itemsReferti = [];
            me.rigaSelezionata = row.item;
            if (row.item.tipo === "CONSULENZA") {
                UtilityMixin.methods.loadDataResources(me.pathResourceRepository, { idRisorsa: row.item.id }, me.loadRefertiSuccess, me.loadRefertiError);
            } else {
                UtilityMixin.methods.loadDataResources(me.pathResourceRepository, { idRisorsa: row.item.codiceRichiesta }, me.loadRefertiSuccess, me.loadRefertiError);
            }
        },
        loadRefertiSuccess(response) {
            let me = this;
            console.log(response.data.data.list);

            me.itemsReferti = response.data.data.list;
        },
        loadRefertiError(response) {
            console.log(response);
        },
        onClickVisualizzaPdf(row) {
            let me = this;
            me.$refs.pdfPrintViewEmbedded.show();
            me.signedPdfViewer = "data:application/pdf;base64," + row.item.base64;
        },
        onShowModalAllegati() {
            let me = this;
            me.jsonDataAllegato = { idRisorsa: me.idAccettazione, file: null, size: null, tipo: null, dataCaricamento: null, descrizione: null, tipoDocumento: null };
        },
        onHideModalAllegati() {
            let me = this;
            me.jsonDataAllegato = { idRisorsa: me.idAccettazione, file: null, size: null, tipo: null, dataCaricamento: null, descrizione: null, tipoDocumento: null };
        },
        onClickNuovoAllegato() {
            let me = this;
            me.jsonDataAllegato = { idRisorsa: me.idAccettazione, file: null, size: null, tipo: null, dataCaricamento: null, descrizione: null, tipoDocumento: null };
            let url = process.env.VUE_APP_PATH_API + "/rsaaccettazioni/" + me.idAccettazione;
            axios
                .get(url)
                .then((response) => {
                    let accettazione = response.data.data;

                    if (accettazione.statoAttuale === "DIMISSIONE" || accettazione.statoAttuale === "TRASFERITO" || accettazione.statoAttuale === "ASSENTE") {
                        let messaggio = accettazione.statoAttuale === "ASSENTE" ? "Non è possibile questa operazione su un paziente assente" : "Non è possibile questa oeprazione su un paziente dimesso";
                        me.$bvModal.msgBoxOk(messaggio, {
                            title: "Attenzione",
                            okVariant: "danger",
                            okTitle: "OK",
                            centered: true,
                        });
                    } else {
                        me.$refs.mdlAllegati.show();
                    }
                })
                .catch((error) => {
                    console.error("Errore nel recupero dei dati accettazione:", error);
                    me.$bvToast.toast("Errore nel recupero dei dati del paziente.", {
                        title: "Errore",
                        variant: "danger",
                        solid: true,
                    });
                });
        },
        onSalvaAllegato() {
            let me = this;
            let obj = me.getDataPdf(me.jsonDataAllegato);
            UtilityMixin.methods.saveResource(me.pathResourceAllegati, obj, me.resultSaveAllegatoResponse, me.resultSaveAllegatoError);
        },
        resultSaveAllegatoResponse() {
            let me = this;
            me.$refs.cmpAllegatoModel.loadData();
            this.$refs["mdlAllegati"].hide();
            me.showModalLoading = false;
            this.$bvToast.toast(`${this.jsonDataAllegato.nomeFile}`, {
                title: "File Upload",
                autoHideDelay: 2000,
                variant: "success",
            });
        },
        resultSaveAllegatoError(error) {
            this.$bvModal.msgBoxOk(error.response.data.messaggio, {
                title: "ATTENZIONE",
                size: "sm",
                okVariant: "outline-danger",
                headerClass: "sa-msg-header-danger",
                footerClass: "p-2 border-top-0",
                centered: true,
            });
        },
        getDataPdf(obj) {
            let objPdf = {};
            objPdf.idRisorsa = obj.idRisorsa;
            objPdf.idAnagrafica = obj.idPaziente;
            objPdf.nomeFile = obj.nomeFile;
            objPdf.size = obj.size;
            objPdf.file = obj.file;
            objPdf.tipo = obj.tipo;
            objPdf.dataCaricamento = obj.dataCaricamento;
            objPdf.dataDocumento = obj.dataCaricamento;
            objPdf.descrizione = obj.descrizione;
            objPdf.tipoDocumento = obj.tipoDocumento;
            return objPdf;
        },
        onUpdateFile() {
            let me = this;
            me.$refs.cmpAllegatoModel.loadData();
        },
        onSaveSuccess(data) {
            let me = this;
            me.loadData(data);
        },
        loadTipiRichiesta() {
            let me = this;
            me.richiestaLaboratorioTipiList = [];
            UtilityMixin.methods.loadDataResources(me.pathResourceRichiestaLaboratorioTipo, null, me.loadTipiRichiestaSuccess, me.loadTipiRichiestaError);
        },
        loadTipiRichiestaSuccess(response) {
            let me = this;
            me.richiestaLaboratorioTipiList = response.data.data.list;
            me.richiestaLaboratorioTipiList.unshift({ codice: "", descrizione: "-Seleziona Valore-" });
        },
        loadTipiRichiestaError(error) {
            let me = this;
            console.log(error);

            me.richiestaLaboratorioTipiList.unshift({ codice: "", descrizione: "-Seleziona Valore-" });
            me.$bvToast.toast("Errore nel caricamento dei dati", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        scaricaCsv() {
            var data = [];
            let nomeFile = "Referti_" + UtilityMixin.methods.formatDateTimeCustom(new Date().getTime(), "YYYY_MM_DD") + ".csv";
            let csvHeaderFinal = [];
            let csvKeysFinal = [];
            let ketToInclude = {};
            if (this.items.length > 0) {
                for (let column of this.columnsProperty) {
                    if (!ketToInclude[column.key]) {
                        ketToInclude[column.key] = {
                            type: column.type ? column.type : "string",
                            label: column.label ? column.label : column.key.toUpperCase(),
                            visible: column.visible ?? true,
                        };
                    }
                }

                Object.keys(this.items[0]).forEach((key) => {
                    if (ketToInclude[key] && ketToInclude[key].visible) {
                        csvKeysFinal.push(key);
                        csvHeaderFinal.push(ketToInclude[key].label);
                    }
                });

                data.push(csvHeaderFinal);

                this.items.forEach((item) => {
                    let row = [];
                    csvKeysFinal.forEach((key) => {
                        let valore = item[key];
                        if (ketToInclude[key].type == "date") {
                            if (valore) {
                                valore = UtilityMixin.methods.formatDate(valore);
                            }
                        }
                        if (valore === null || valore === undefined) {
                            valore = "";
                        } else {
                            valore = String(valore);
                            if (["codiceRichiesta"].includes(key)) {
                                valore = `="${valore.replace(/"/g, '""')}"`;
                            } else {
                                valore = valore.replace(/"/g, '""');
                                if (valore.includes(";") || valore.includes("\n") || valore.includes('"')) {
                                    valore = `"${valore}"`;
                                }
                            }
                        }
                        row.push(valore);
                    });
                    data.push(row);
                });
            }
            let dataString = "";
            var csvContent = "";
            data.forEach(function (infoArray, index) {
                dataString = infoArray.join(";");
                csvContent += index < data.length ? dataString + "\n" : dataString;
            });

            // The download function takes a CSV string, the filename and mimeType as parameters
            // Scroll/look down at the bottom of this snippet to see how download is called
            var download = function (content, fileName, mimeType) {
                var a = document.createElement("a");
                mimeType = mimeType || "application/octet-stream";

                if (navigator.msSaveBlob) {
                    // IE10
                    navigator.msSaveBlob(
                        new Blob([content], {
                            type: mimeType,
                        }),
                        fileName,
                    );
                } else if (URL && "download" in a) {
                    //html5 A[download]
                    a.href = URL.createObjectURL(
                        new Blob([content], {
                            type: mimeType,
                        }),
                    );
                    a.setAttribute("download", fileName);
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                } else {
                    location.href = "data:application/octet-stream," + encodeURIComponent(content); // only this mime type is supported
                }
            };

            download(csvContent, nomeFile, "text/csv;encoding:utf-8");
        },
    },
};
</script>
<style scoped>
.sa-date-like-input >>> .mx-icon-calendar,
.sa-date-like-input >>> .mx-icon-clear {
    display: none !important;
}
</style>
